import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import "moment-timezone";
import { Dropdown } from "primereact/dropdown";
import videoIcon from "../../../assets/img/icons/video-icon.svg";
import CustomerService from "../../../services/customer/customer.service";
import SiteService from "../../../services/sites/sites.service";
import { AppDispatch, AppState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { addCustomersData } from "../../../store/common";
import routerIcon from "../../../assets/img/icons/route-icon-yellow.svg";
import { PermissionsContext } from "../../../providers/PermissionsProvider";
import { useNavigate } from "react-router-dom";
import Helpers, { getDateTimeTzByTimeZone, getTimzeZoneForAPI } from "../../../utils/helpers";
import { SelectedSiteReducer,SelectedCustomerReducer } from "../../../store/inspection-overview/site-operations/survey-details.store";
import { SelectedSiteReducer as VsurveySelectedSiteReducer } from "../../../store/voluntary-survey/site-operations/survey-details.store";
import SiteOperationsService from "../../../services/inspection-overview/site-operations/survey.services";
import { downloadIcon } from "../../../constants/icons.constants";
import VoluntarySurveyService from "../../../services/voluntary-surveys/voluntarysurvey.services";
import { useLocation } from 'react-router-dom';

interface SitesDropdownProps {
  name: string;
  code: string;
  cameraSiteId: string;
  lastSurveyDate: string;
  nextSurveyDate: string;
  latitude: string;
  longitude: string;
}
const HeaderComponent: React.FC<any> = (props: any) => {
  const {
    updateVisible,
    selectedMenu,
    selectedValue,
    setTabDisplaytoggle,
    selectedHeaderInfo,
    setSurveyData,
    selectedSiteName,
    updateVoluntarySurvey,
    setVSurveyHistoryData
  } = props;
  const SitesDropdownInit = {
    name: "",
    code: "",
    cameraSiteId: "",
    lastSurveyDate: "",
    nextSurveyDate: "",
    latitude: "",
    longitude: "",
  }
  const routeLocation:any = useLocation() || "";

  const btnDisabled = {fontSize: '1.2rem', color:"#808080", cursor:"default", marginTop:"5px"};
  const btnEnabled = {fontSize: '1.2rem', color:"#12B76A", cursor:"pointer", marginTop:"5px"};
  const btnReset = {fontSize: '1.2rem', color:"#F04438", cursor:"pointer", marginTop:"5px"};
  
  const { globalAdmin,readOnlyGlobalAdmin, customerAdmin } = useContext(PermissionsContext);
  //canAccessEditSiteUpload is for only superAdmin, checking the current user is a super amdin or not
  const UserSettings_Redux:any = useSelector((state: any) => state.UserPreferenceState.userSettings);
  const CustData_Redux:any = useSelector((state: AppState) => state.AuraCameraCommon.CustData);
  const SiteData_Redux:any = useSelector((state: AppState) => state.AuraCameraCommon.SiteData);
  const selectedCustomerInfo_Redux:any = useSelector((state: AppState) => state.SurveyDetails.selectedCustomerInfo);
  const SelectedSiteInfo_Redux = useSelector((state: AppState) => state.SurveyDetails.selectedSiteInfo);
  const [userTz, setUserTz] = useState<string>("");
  
  const [custList, custListUpdate] = useState<any>(CustData_Redux);
  const [selectedCustomer, setSelectedCustomer] = useState<any>(selectedHeaderInfo?.selectedCustomer);
  
  const [sitesByCustomer, setSitesByCustomer] = useState<any>(SiteData_Redux as SitesDropdownProps[]);
  const [selectedSite, setSelectedSite] = useState<SitesDropdownProps>(SitesDropdownInit);
  
  const [datetime12h, setDateTime12h] = useState<any>(moment(new Date()));
  const [headerEleDisplay, setheaderEleDisplay] = useState<boolean>(false);
  const [disableProceedState, setDisableProceedState] = useState<boolean>(true);
  const [isVoluntaryDetails, setIsVoluntaryDetails] = useState<boolean>((routeLocation?.pathname === "/voluntary-details"?true:false));
  const [isRegulatoryDetails, setIsRegulatoryDetails] = useState<boolean>((routeLocation?.pathname === "/regulatory-details"?true:false));
  const lastCustomerIdRef = useRef<string | null>(null);

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (routeLocation.pathname === "/voluntary-details" || routeLocation.pathname === "/regulatory-details") {
      setheaderEleDisplay(true);
    } else if (
      routeLocation.pathname.includes("/voluntary-surveys") ||
      routeLocation.pathname.includes("/regulatory-surveys") ||
      routeLocation.pathname.startsWith("/asset-summary")
    ) {
      setheaderEleDisplay(false);
    } else {
      setheaderEleDisplay(false);
    }
  }, [routeLocation.pathname]);

  useEffect(()=>{
    if(routeLocation?.pathname === "/voluntary-details"){
      setIsRegulatoryDetails(false);
      setIsVoluntaryDetails(true);
    }else if(routeLocation?.pathname === "/regulatory-details"){
      setIsRegulatoryDetails(true);
      setIsVoluntaryDetails(false);
    }else{
      setIsRegulatoryDetails(false);
      setIsVoluntaryDetails(false);
    }
  },[routeLocation?.pathname])

  const handleSurveyHistoryButtonClick = () => {
    updateVisible(true);
    fetchSurveyHistoryData();
  };
  const fetchSurveyHistoryData = useCallback(async () => {
    if (selectedHeaderInfo && selectedHeaderInfo.cameraSiteId) {
      try {
        const data = await SiteOperationsService.getSurveyHistory(selectedHeaderInfo.cameraSiteId);
        setSurveyData(data);
        if((selectedHeaderInfo?.selectedSite?.code && SelectedSiteInfo_Redux?.code) && (selectedHeaderInfo?.selectedSite?.code !== SelectedSiteInfo_Redux?.code)){
          // If both are not equel then, it's direct change from site dropdown, 
          // so need to take 'SelectedSiteInfo_Redux', else it's a default redirection from Global inspection overview page so take 'selectedHeaderInfo.selectedSite'
          const data = await SiteOperationsService.getSurveyHistory(SelectedSiteInfo_Redux.cameraSiteId);
          setSurveyData(data);
        }else{
          const data = await SiteOperationsService.getSurveyHistory(selectedHeaderInfo.cameraSiteId);
          setSurveyData(data);
        }
      } catch (error) {
        console.error("Error survey data:", error);
      }
    }
  },[selectedHeaderInfo?.cameraSiteId,SelectedSiteInfo_Redux?.cameraSiteId]);

  const handleVoluntarySurveyHistoryButtonClick = () => {
    updateVoluntarySurvey(true);
    fetchVoluntarySurveyHistoryData();
  };

const fetchVoluntarySurveyHistoryData = useCallback(async () => {
  if (selectedHeaderInfo && selectedHeaderInfo.cameraSiteId) {
    try {
      if((selectedHeaderInfo?.selectedSite?.code && SelectedSiteInfo_Redux?.code) && (selectedHeaderInfo?.selectedSite?.code !== SelectedSiteInfo_Redux?.code)){
         // If both are not equel then, it's direct change from site dropdown, 
         // so need to take 'SelectedSiteInfo_Redux', else it's a default redirection from Global inspection overview page so take 'selectedHeaderInfo.selectedSite'
        const data = await VoluntarySurveyService.getVSurveyHistory(SelectedSiteInfo_Redux.cameraSiteId);
        setVSurveyHistoryData(data);
      }else{
        const data = await VoluntarySurveyService.getVSurveyHistory(selectedHeaderInfo.cameraSiteId);
        setVSurveyHistoryData(data);
      }
    } catch (error) {
      console.error("Error survey data:", error);
    }
  }
},[selectedHeaderInfo?.cameraSiteId,SelectedSiteInfo_Redux?.cameraSiteId]);

  const fetchAllSitesByCustomer = async (customerId:any,customerName:any, onLoading?:boolean) : Promise<void> => {
    if (lastCustomerIdRef.current === customerId) return;
    lastCustomerIdRef.current = customerId;
    let isVoluntarySurveyCall = routeLocation.pathname?.includes("/voluntary")?2:1;
    try {
      const res = await SiteService.getAllSitesByCustomer(customerId, customerName, isVoluntarySurveyCall);
      if (res && Array.isArray(res)) {
        const updatedSitesDDList = res.map((el: any) => ({
          name: el.siteName,
          code: el.siteId,
          cameraSiteId: el.cameraSiteId,
          lastSurveyDate: el.lastSurveyDate,
          nextSurveyDate: el.estimatedNextSurveyDate,
          latitude: el.coordinates.latitude,
          longitude: el.coordinates.longitude,
        }));
          setSitesByCustomer([...updatedSitesDDList]); // Set sites dropdown option values based on customer.
          if (onLoading) {
            setSelectedSite(selectedHeaderInfo?.selectedSite); // Set the selected site value, once all sites loaded based on customer for Sites Dropdown.
          }
      } else {
        console.log("getAllSitesByCustomer: No data found");
      }
    } catch (error) {
      console.error("Error fetching site data:", error);
    }
  }
  const updateWithEmpty = ()=>{
    setSitesByCustomer([]);
    setSelectedSite(SitesDropdownInit);
  }
  const backToPrevious = () => {
    navigate("/");
    setheaderEleDisplay(false);
    setTabDisplaytoggle(true);
  };
  const backToMain = () => {
    navigate("/");
    setheaderEleDisplay(true);
    setTabDisplaytoggle(false);
  };
  const handleVoluntarySurveysClick = () => {
    if (window.history.length > 1) {
      navigate("/voluntary-surveys"); 
    } else {
      navigate("/"); 
    }
  };
  const handleRegulatorySurveysClick = () => {
    navigate("/regulatory-surveys");
    setheaderEleDisplay(false);
    setTabDisplaytoggle(true);
  };
  
  const getSelectedMenuName = (menu: string) => {
    let path = window.location.pathname;
    if((!menu || menu ==="" || menu ==="/" || menu ==="Home" || routeLocation?.pathname ==="/") && path ==="/"){
      return (
        <>
          <div className="breadcrumb-title">
            <a>AURA Dashboard</a>
          </div>
        </>
      );
    }else if(path.startsWith("/voluntary-details") || path.startsWith("/voluntary-surveys") ||  menu === "voluntary-surveys" || menu === "Voluntary Surveys" || menu === "Map view voluntary" || menu === "List view voluntary" || menu === "Pinned voluntary" || routeLocation?.pathname === "/voluntary-surveys/listview" || routeLocation?.pathname === "/voluntary-details" ){
      return (
        <>
          <div className="breadcrumb-title">
            <a onClick={backToMain}>AURA Dashboard</a>
          </div>
          <div className="breadcrumb-split"> \ </div>
          <div className="breadcrumb-subtitle">
            <span
              onClick={handleVoluntarySurveysClick}
              style={{
                cursor: isVoluntaryDetails ? "pointer" : "default",
                color: isVoluntaryDetails ? "#FFB217" : ""
              }}
            >
              {Helpers.capitalizeString("Voluntary Surveys")}
            </span>
          </div>
        </>
      );
    }else if (path.startsWith("/regulatory-details") || path.startsWith("/regulatory-surveys") || menu === "regulatory-surveys" || menu === "Map view regulatory"|| menu === "List view regulatory" || menu === "Pinned regulatory" || routeLocation?.pathname ==="/regulatory-surveys/listview" || routeLocation?.pathname ==="/regulatory-details" ) {
      return (
        <>
          <div className="breadcrumb-title">
            <a onClick={backToMain}>AURA Dashboard</a>
          </div>
          <div className="breadcrumb-split"> \ </div>
          <div className="breadcrumb-subtitle">
            <span
              onClick={handleRegulatorySurveysClick}
              style={{
                cursor: isRegulatoryDetails ? "pointer" : "default",
                color: isRegulatoryDetails ? "#FFB217" : ""
              }}
            >
              {Helpers.capitalizeString("Regulatory Surveys")}
            </span>
            </div>
        </>
      );
    }else if (menu === "asset-summary" || menu === "Asset Summary" || menu === "Site summary" || menu === "Camera operator") {
      return (
        <>
          <div className="breadcrumb-title">
            <a onClick={backToMain}>AURA Dashboard</a>
          </div>
          <div className="breadcrumb-split"> \ </div>
          <div className="breadcrumb-subtitle">
            {Helpers.capitalizeString("Asset Summary")}
          </div>
        </>
      );
    }else if (menu === "reports" || menu === "Reports") {
      return (
        <>
          <div className="breadcrumb-title">
            <a onClick={backToMain}>AURA Dashboard</a>
          </div>
          <div className="breadcrumb-split"> \ </div>
          <div className="breadcrumb-subtitle">
            {Helpers.capitalizeString("Reports")}
          </div>
        </>
      );
    }else if (menu === "user") {
      return (
        <>
          <div className="breadcrumb-title">
            <a onClick={backToMain}>AURA Dashboard</a>
          </div>
          <div className="breadcrumb-split"> \ </div>
          <div className="breadcrumb-subtitle">
            {Helpers.capitalizeString("User")}
          </div>
        </>
      );
    }else if (menu === "signout") {
      return (
        <>
          <div className="breadcrumb-title">
            <a onClick={backToMain}>AURA Dashboard</a>
          </div>
          <div className="breadcrumb-split"> \ </div>
          <div className="breadcrumb-subtitle">
            {Helpers.capitalizeString("Signout")}
          </div>
        </>
      );
    }
  };
  const siteOnchangeHandler = (evt:any) =>{
      setSelectedSite(evt.target.value);
      setDisableProceedState(false);
  }
  const customerOnchangeHandler = (evt:any) =>{
      setSelectedCustomer(evt.target.value);
      setSelectedSite(SitesDropdownInit);
      setDisableProceedState(false);
      dispatch(SelectedCustomerReducer(evt.target.value as any));
  }
  const proceedHandler = (selectedSiteParam :any)=>{
    dispatch(SelectedSiteReducer(selectedSiteParam as any));
    dispatch(VsurveySelectedSiteReducer(selectedSiteParam as any));
  }

  const resetSiteHandler = () => {
    setDisableProceedState(true); 
    setSelectedCustomer(props?.selectedHeaderInfo?.selectedCustomer); 
    setSelectedSite(SitesDropdownInit);
    fetchAllSitesByCustomer(props?.selectedHeaderInfo?.selectedCustomer?.customerId,props?.selectedHeaderInfo?.selectedCustomer?.name,true);
    setTimeout(() => {
      proceedHandler(selectedHeaderInfo?.selectedSite);
    }, 500);
  };

  useEffect(() => {
    const userTimeZone = UserSettings_Redux.timeZone;
    const timeZoneForAPI = getTimzeZoneForAPI(userTimeZone);
    setUserTz(timeZoneForAPI);
  }, [UserSettings_Redux]);

  useEffect(() => {
     if(sitesByCustomer.length && selectedSite && selectedSite.name !== ""){
      //setDisableProceedState(false);
     }else{
      setDisableProceedState(true);
     }
  }, [selectedSite]);

  useEffect(()=>{
    // Onlaoding the page default fetch -  Filter sites based on the customer selection
    setDisableProceedState(true);
    if(selectedHeaderInfo && selectedHeaderInfo.selectedCustomer?.customerId){
      // fetchAllSitesByCustomer(selectedHeaderInfo.selectedCustomer?.customerId,selectedHeaderInfo.selectedCustomer?.name,true);
      proceedHandler(selectedHeaderInfo?.selectedSite);
      setSelectedCustomer(selectedHeaderInfo?.selectedCustomer);
      dispatch(SelectedCustomerReducer(selectedHeaderInfo?.selectedCustomer as any));
    }
  },[selectedHeaderInfo.selectedCustomer])

  useEffect(()=>{
    // On change of Customer Dropdown - Filter sites based on the customer selection
    if(selectedHeaderInfo && selectedCustomerInfo_Redux?.customerId && selectedCustomerInfo_Redux?.customerId != null){
      fetchAllSitesByCustomer(selectedCustomerInfo_Redux?.customerId,selectedCustomerInfo_Redux?.name);
    }else{
      updateWithEmpty();
    }
  },[selectedCustomerInfo_Redux])

  useEffect(() => {
    let routeUrl = window?.location?.pathname;
    if (routeUrl.includes("/regulatory-details") || routeUrl.includes("/voluntary-details")) {
      setheaderEleDisplay(true); 
    }else{
      setheaderEleDisplay(false); 
    }
  }, [selectedMenu,window?.location?.pathname]);

  useEffect(() => {
    if (selectedSite != null && props.selectedHeaderInfo) {
      setheaderEleDisplay(true);
      props?.selectedHeaderInfo?.selectedSite && setSelectedSite(props?.selectedHeaderInfo?.selectedSite);
      if(props?.selectedHeaderInfo?.selectedCustomer && props?.selectedHeaderInfo?.selectedCustomer?.name != null){
         setSelectedCustomer(props?.selectedHeaderInfo?.selectedCustomer);
      }
      // Only hide survey Map/List/Pinned tabs on site-operation detail routes. Do not hide them on
      // map/list/pinned overview pages — `selectedHeaderInfo` updates there (e.g. marker click) and
      // would otherwise override `RouteSync` and remove the tab bar.
      const path = routeLocation.pathname || "";
      if (path.includes("/regulatory-details") || path.includes("/voluntary-details")) {
        setTabDisplaytoggle(false);
      } else if (
        path.startsWith("/regulatory-surveys") ||
        path.startsWith("/voluntary-surveys") ||
        path.startsWith("/asset-summary")
      ) {
        setTabDisplaytoggle(true);
      }
    }
  }, [props.selectedHeaderInfo, routeLocation.pathname, setTabDisplaytoggle]);

  useEffect(() => {
    if (CustData_Redux.length === 0) {
      CustomerService.getCustomerList()
        .then((res: any) => {
          if (res && Array.isArray(res)) {
            const formatResp = res.map((el: any) => ({
              name: el.name,
              code: el.customerID,
              customerId: el.customerID
            }));
            dispatch(addCustomersData(formatResp as any));
            custListUpdate(formatResp);
            setSelectedCustomer(selectedHeaderInfo?.selectedCustomer);
          } else {
            console.log("getCustomerList: No data found");
          }
        })
        .catch((error) => {
          console.error("Error fetching site data:", error);
        });
    } else {
      custListUpdate(CustData_Redux);
      dispatch(SelectedCustomerReducer(selectedHeaderInfo.selectedCustomer as any));
      setSelectedCustomer(selectedHeaderInfo.selectedCustomer);
    }
  }, []);
  return (
    <>
      {/* Breadcrumb start */}
      <div className="hdr-left d-flex">
        {getSelectedMenuName(selectedMenu)}
          {/* Site Operation page - Customer & Site selection start */}
          {(globalAdmin || readOnlyGlobalAdmin || customerAdmin) &&
            headerEleDisplay && (
              <>
                <div className="breadcrumb-split"> \</div>
                <div className="site-dropdown ps-2">
                  {/* Customer Dropdown */}
                  <Dropdown
                    className="header-customer-dropdown"
                    value={selectedCustomer}
                    options={custList}
                    onChange={(e: any) => {
                      customerOnchangeHandler(e);
                    }}
                    optionLabel="name"
                    filter
                    filterBy="name"
                    disabled={customerAdmin}
                  />
                </div>
              </>
            )}
          {headerEleDisplay && (
            <>
              <div className="breadcrumb-split"> \</div>
              <div className="site-dropdown ps-2">
                {/* Site Dropdown */}
                <Dropdown
                  className="header-sites-dropdown"
                  value={selectedSite}
                  options={sitesByCustomer}
                  onChange={(e: any) => siteOnchangeHandler(e)}
                  optionLabel="name"
                  filter
                  filterBy="name"
                />
              </div>
              {/* Proceed & Reset button start */}
              <div className="flex ml-3 mt-1">
                {disableProceedState && (
                  <>
                    <i style={btnDisabled} className="pi pi-arrow-circle-right" 
                      title="Select a site to Proceed"
                      onClick={() =>
                      !disableProceedState
                        ? proceedHandler(selectedSite)
                        : () => {}
                      }
                    ></i>
                    <i
                      style={btnDisabled}
                      className="pi pi-times-circle ml-2"
                      title="Cancel the process and reset"
                      onClick={resetSiteHandler}
                    ></i>
                  </>
                )}
                {!disableProceedState && (
                  <>
                  <i
                    style={btnEnabled}
                    className="pi pi-arrow-circle-right"
                    title="Proceed with selected site"
                    onClick={() => proceedHandler(selectedSite)}
                  ></i>
                  <i
                    style={btnReset}
                    className="pi pi-times-circle ml-2"
                    title="Cancel the process and reset"
                    onClick={resetSiteHandler}
                  ></i>
                  </>
                )}
              </div>
              {/* Proceed & Reset button end */}
            </>
          )}
          {/* Site Operation page - Customer & Site selection end */}
      </div>
      {/* Breadcrumb end */}
      <div className="hdr-right d-flex justify-content-end pr-2">
        {headerEleDisplay && (
          <>
            {/* <label className="site-data rounded-lg ps-3 pe-3 ms-4 rounded-pill justify-content-center align-items-center">
              Site data : {siteDataStatus ? ` Uploaded` : ` No site data uploaded`}
            </label> */}
            {selectedValue === "Show training data" ? (
              <label
                className="video-survey rounded-lg ps-3 pe-3 rounded-pill justify-content-center align-items-center"
                onClick={() => updateVisible(true)}
                style={{ cursor: "pointer" }}
              >
                <img src={routerIcon} alt="Route Icon" />
                &nbsp;Show training data
              </label>
            ) : (
             <>
                {!isVoluntaryDetails ?
                  <label
                    className="video-survey rounded-lg ps-3 pe-3 rounded-pill justify-content-center align-items-center flex"
                    onClick={handleSurveyHistoryButtonClick}
                    style={{ cursor: "pointer" }}
                  >
                    <div><img src={videoIcon} alt="Video Icon" /></div> <div>Site Survey History</div>
                  </label>
                  :
                  <label
                  className="video-survey rounded-lg ps-3 pe-3 rounded-pill justify-content-center align-items-center flex"
                  style={{ cursor: "pointer" }}
                  onClick={handleVoluntarySurveyHistoryButtonClick}
                >
                  <div><img src={videoIcon} alt="Video Icon" /></div> <div>Site Survey History</div>
                </label>
                }
              </>
            )}
          </>
        )}
        {/* {isVoluntaryDetails && (
          <>
            <label
              className="video-survey rounded-lg ps-3 pe-3 rounded-pill justify-content-center align-items-center"
              style={{ cursor: "pointer" }}
            >
              Survey History
            </label>
            <label
              className="video-survey rounded-lg ps-3 pe-3 rounded-pill justify-content-center align-items-center"
              style={{ cursor: "pointer" }}
            >
              {downloadIcon}Download Report
            </label>
          </>
        )} */}
        <label className="site-data rounded-lg ps-3 pe-3 ms-4 rounded-pill justify-content-center align-items-center">
          <i className="pi pi-clock pt-1" style={{ color: "#ffffff", top:"2px", position:"relative", fontSize:"14px" }} />
          &nbsp;<span>As of</span>
          <span className="calendar-date-display pl-1">
            {getDateTimeTzByTimeZone(datetime12h, userTz)}
          </span>
        </label>
      </div>
    </>
  );
};
export default HeaderComponent;
